module.exports = __webpack_public_path__ + "img/rennes-logo-icon.e8801fa3.png";